import React, { useEffect, useState } from "react";

import {
  Segment,
  Input,
  Icon,
  Grid,
  Loader,
  Button,
  Popup,
} from "semantic-ui-react";
import {
  getProveedoresList,
  deleteProveedor,
  getReportProveedores,
} from "../../../../api/Lizen/proveedor";
import { addHash } from "../../../../api/Common/report";
import { ModalBasic, PaginationTable, FiltersLizenProveedor, Reports, getPermissionsSecondary } from "../../../../components/Common";
import {
  useHistory,
} from "react-router-dom";
import { ListadoProveedores } from "../../../../components/Admin/Lizen";
import { HeaderPage } from "../../../../components/Admin";
import { toast } from "react-toastify";
import "./AbmAdmin.scss";
import { getPermissions } from "../../../../components/Common";
import { useAuth, useNotification } from "../../../../hooks";
import { animateScroll as scroll } from "react-scroll";

export function ProveedorLizenList() {
  const { auth } = useAuth();
  const { startInterval } = useNotification();
  const [proveedores, setProveedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState(null);
  const [dataModal, setDataModal] = useState(null);
  const [contentModal, setContentModal] = useState(null);
  const [refetch, setRefetch] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [countPage, setCountPage] = useState(1);
  const [searchActive, setSearchActive] = useState("");
  const [filtersActive, setFiltersActive] = useState("");
  const [openFilter, setOpenFilter] = useState(false);

  const limitPagination = 10;
  const history = useHistory();
  const fetchProveedores = async (request = null) => {
    const proveedores = await getProveedoresList(request);

    setProveedores(proveedores.results);
    setCountPage(proveedores.count);
    setLoading(false);
  };
  useEffect(() => {
    scroll.scrollToTop();
    let filtrosExistentes = sessionStorage.getItem("lizen_proveedores_filters");
    let searchExistentes = sessionStorage.getItem("lizen_proveedores_search");
    if (searchExistentes) {
      setSearchActive(searchExistentes);
      setFiltersActive(filtrosExistentes || "");
      fetchProveedores(
        filtrosExistentes !== ""
          ? `page=1&paginate=true&is_active=1&search=${searchExistentes}&${filtrosExistentes}`
          : `page=1&paginate=true&is_active=1&search=${searchExistentes}`
      );
    } else if (filtrosExistentes) {
      setFiltersActive(filtrosExistentes);
      fetchProveedores(`page=1&paginate=true&is_active=1&${filtrosExistentes}`);
    } else {
      fetchProveedores(`page=1&paginate=true&is_active=1`);
    }
  }, [refetch]);

  const onRefetch = () => setRefetch((prev) => !prev);
  const openCloseModal = () => {
    setShowModal((prev) => !prev);
  };
  const onDeleteProveedor = async (proveedor) => {
    setContentModal(
      <p>Desea eliminar el proveedor {proveedor.razon_social} ?</p>
    );
    setTitleModal("Eliminar proveedor");
    setShowModal(true);
    setDataModal(proveedor.id);
  };
  const openConfirmModal = async (id) => {
    try {
      let response = await deleteProveedor(id);

      toast.success(response.data);
      setShowModal(false);
      onRefetch();
    } catch (error) {
      console.error("Error en ProveedorLizenList:", error);
    }
  };
  const crearProveedor = (id) => {
    history.push(`/admin/proveedor_lizen/crear`);
  };

  const onEditProveedor = (proveedor) => {
    history.push(`/admin/proveedor_lizen/edit/id/${proveedor.id}`);
  };
  const onShowProveedor = (proveedor) => {
    history.push(`/admin/proveedor_lizen/show/id/${proveedor.id}`);
  };

  const openConfirmModalFilters = (formData) => {
    let respuesta_final = [];

    if (formData.proveedor_provincia !== undefined && formData.proveedor_provincia.length > 0) {
      respuesta_final.push(`provincia=${formData.proveedor_provincia.join(",")}`);
    }
    if (formData.proveedor_localidad !== undefined && formData.proveedor_localidad.length > 0) {
      respuesta_final.push(`localidad=${formData.proveedor_localidad.join(",")}`);
    }

    let request = `page=1&paginate=true&is_active=1`;
    if (searchActive !== "") request += `&search=${searchActive}`;
    if (respuesta_final.length > 0) request += `&${respuesta_final.join("&")}`;

    fetchProveedores(request);
    sessionStorage.setItem("lizen_proveedores_filters", respuesta_final.join("&"));
    setFiltersActive(respuesta_final.join("&"));
    setOpenFilter((prev) => !prev);
    setLoading(true);
    setActivePage(1);
  };

  const openCloseModalFilters = () => {
    setOpenFilter((prev) => !prev);
  };

  const openClearFilters = () => {
    fetchProveedores(`page=1&paginate=true&is_active=1${searchActive ? `&search=${searchActive}` : ""}`);
    setFiltersActive("");
    sessionStorage.removeItem("lizen_proveedores_filters");
    setOpenFilter((prev) => !prev);
    setLoading(true);
    setActivePage(1);
    onRefetch();
  };

  const onFilters = () => {
    setOpenFilter(true);
  };

  const onReports = async () => {
    let queryParams = filtersActive;
    if (searchActive !== "") {
      queryParams = `search=${searchActive}&` + queryParams;
    }
    const response = await getReportProveedores(queryParams);
    if (response) {
      addHash(response.hash);
      startInterval();
    }
  };

  const onSearch = (e) => {
    const value = e.target.value;
    setSearchActive(value);
    sessionStorage.setItem("lizen_proveedores_search", value);
    let request = `page=1&paginate=true&is_active=1&search=${value}`;
    if (filtersActive !== "") request += `&${filtersActive}`;
    fetchProveedores(request);
    setActivePage(1);
  };

  const onChange = (e, pageInfo) => {
    let request = `page=${pageInfo.activePage.toString()}&paginate=true&is_active=1`;
    if (searchActive !== "") request += `&search=${searchActive}`;
    if (filtersActive !== "") request += `&${filtersActive}`;
    fetchProveedores(request);
    setActivePage(pageInfo.activePage);
  };

  const BotonFiltros = () => {
   return(
      <Popup
        content="Ver filtros"
        trigger={
          <Button
            onClick={onFilters}
            icon={<Icon name="filter" className="color_search" inverted circular />}
            inverted
          />
        }
      />
    )
  };
  return (
    <div>
      <HeaderPage
        title="Proveedores"
        btnTitle="Agregar proveedor"
        btnClick={crearProveedor}
        permitionName="add_proveedor"
      />

      <Grid as={Segment} className="segment_search">
        <Grid.Row>
          <Grid.Column computer={3} mobile={16} tablet={16}>
            <Input
              fluid
              icon={
                <Icon
                  name="search"
                  className="color_search"
                  inverted
                  circular
                />
              }
              className="input_search"
              inverted
              placeholder="Buscar..."
              value={searchActive}
              onChange={onSearch}
            />
          </Grid.Column>
          <Grid.Column computer={1} mobile={16} tablet={16}>
            <BotonFiltros />
          </Grid.Column>
          <Grid.Column computer={10} mobile={16} tablet={16}>
            <Reports confirmReports={onReports} />
          </Grid.Column>
          <br></br>
          <Grid.Column computer={2} mobile={16} tablet={16}>
            {getPermissions("add_proveedor", auth) && (
              <Button circular basic positive onClick={crearProveedor}>
                Agregar proveedor
              </Button>
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <Grid>
        <Grid.Row>
          <Grid.Column computer={16}></Grid.Column>
        </Grid.Row>
      </Grid>

      {loading ? (
        <Loader active inline="centered">
          Cargando...
        </Loader>
      ) : (
        <ListadoProveedores
          proveedores={proveedores}
          onDeleteProveedor={onDeleteProveedor}
          onEditProveedor={onEditProveedor}
          onShowProveedor={onShowProveedor}
          countPage={countPage}
          pagination={
            <PaginationTable
              proveedores={proveedores}
              onChange={onChange}
              activePage={activePage}
              countPage={countPage}
              limitPagination={limitPagination}
            />
          }
        />
      )}

      <ModalBasic
        show={showModal}
        size="small"
        title={titleModal}
        children={contentModal}
        onClose={openCloseModal}
        onConfirm={openConfirmModal}
        dataModal={dataModal}
      />

      <FiltersLizenProveedor
        show={openFilter}
        onClose={openCloseModalFilters}
        onConfirm={openConfirmModalFilters}
        onClear={openClearFilters}
        auth={auth}
        type="lizen"
      />
    </div>
  );
}
